import { NextSeo } from 'next-seo';
import { getContainer } from '@framework/di/getContainer';
import searchEngineConfig from '@framework/config/searchEngine';
import { ISeoService } from './ISeoService';
import { TYPES } from './types';

export interface IPageSeo {
  title?: string,
  description?: string,
  url?: string,
}

export const PageSeo = ({ title, description, url }: IPageSeo) => {
  const container = getContainer();
  const seoService = container.get<ISeoService>(TYPES.SeoService);
  const appTitle = seoService.getAppTitle(title);

  return (
    <NextSeo
      title={ appTitle }
      description={ description }
      openGraph={ { url, title: appTitle, description } }
      noindex={ !searchEngineConfig.allowIndexing }
      nofollow={ !searchEngineConfig.allowIndexing }
    />
  );
};

export default PageSeo;
